module.exports = __webpack_public_path__ + "media/images/buriel-7-7b2bc89000ebae105c67b9328db35d87.png";